@if (authorizedEdition && !addNewIsVisible) {
  <button class="button-add-task" (click)="switchVisibilityAddNew()">
    <i class="icon icon-plus"></i>Ajouter un élément
  </button>
}
@if (addNewIsVisible) {
  <app-add-new-item-checklist (addItem)="setItemAdded($event)">
  </app-add-new-item-checklist>
}
@if (this.checklist) {
  <div (cdkDropListDropped)="drop($event)" cdkDropList class="task-container">
    @for (item of checklist.elements; track item) {
      <div cdkDrag [cdkDragDisabled]="isDragDisabled()" class="liste-item">
        <app-item-checklist
          [item]="item"
          [order]="getOrder(item)"
          [editable]="authorizedEdition"
          [canDelete]="canDelete"
          (changeItem)="setItemChanged($event)"
          (deleteItem)="setItemDeleted($event)">
        </app-item-checklist>
      </div>
    }
  </div>
}
